import { motion } from 'framer-motion';
import { SITE } from '@/constants/testIds';
import { BrandMark, Wordmark } from '@/components/site/Logo';
import { QUOTE_MAILTO, EMAIL } from '@/constants/contact';

export function Footer() {
  return (
    <footer
      id="contact"
      data-testid={SITE.footer}
      className="relative bg-foreground text-background overflow-hidden scroll-mt-24"
    >
      <div className="max-w-[1500px] mx-auto px-6 lg:px-14 py-24 lg:py-32">
        <div className="grid grid-cols-12 gap-6 items-end mb-16">
          <div className="col-span-12 lg:col-span-8">
            <span className="label text-background/60">— Let’s talk</span>
            <motion.h2
              data-testid={SITE.footerCta}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
              className="font-heading font-light uppercase tracking-[-0.03em] leading-[0.85] text-[16vw] lg:text-[13vw] mt-4"
            >
              Say hi.
            </motion.h2>
          </div>
          <div className="col-span-12 lg:col-span-4">
            <a
              href={QUOTE_MAILTO}
              className="inline-flex items-center gap-3 border border-background/40 text-background px-6 py-4 label hover:bg-[hsl(var(--gold))] hover:text-foreground hover:border-[hsl(var(--gold))] transition-colors"
            >
              Request a quote →
            </a>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 border-t border-background/10 pt-16">
          <div className="col-span-12 md:col-span-4">
            <div className="flex items-center gap-3 relative">
              <BrandMark className="w-14 h-14 shrink-0" />
              <Wordmark size="lg" />
            </div>
            <p className="mt-8 font-serif italic font-light text-lg leading-snug text-background/80 max-w-xs">
              Streak-free windows, delivered with a little quiet magic.
            </p>
          </div>

          <div className="col-span-12 md:col-span-4">
            <span className="label text-background/50">Contact</span>
            <ul className="mt-6 space-y-3">
              <li>
                <a
                  data-testid={SITE.footerPhone}
                  href="tel:+17204661749"
                  className="font-serif italic font-light text-2xl leading-tight hover:text-[hsl(var(--gold-light))] transition-colors"
                >
                  720-466-1749
                </a>
              </li>
              <li>
                <a
                  data-testid={SITE.footerEmail}
                  href={`mailto:${EMAIL}`}
                  className="font-serif italic font-light text-xl lg:text-2xl leading-tight break-all hover:text-[hsl(var(--gold-light))] transition-colors"
                >
                  {EMAIL}
                </a>
              </li>
            </ul>
            <ul className="mt-6 space-y-1.5 text-[14px] font-light text-background/75">
              <li>Hours · 8am – 6pm</li>
              <li>Service area · Colorado Front Range</li>
            </ul>
          </div>

          <div className="col-span-12 md:col-span-4">
            <span className="label text-background/50">The standard</span>
            <ul className="mt-6 space-y-2.5 text-[15px] font-light text-background/85">
              <li>Streak-free guarantee</li>
              <li>Interior · Exterior · Screens · Tracks</li>
              <li>Fully Insured</li>
            </ul>
          </div>
        </div>

        <div className="mt-24 flex flex-col items-center justify-center gap-4 border-t border-background/10 pt-8 text-center">
          <div className="label text-background/50">
            © {new Date().getFullYear()} Window Wizards
          </div>
          <div className="label text-background/50">
            Made with care · Streaks not included. 💯
          </div>
        </div>
      </div>
    </footer>
  );
}
